module.exports = __webpack_public_path__ + "static/offer-fizjoteriapia-image-2@2x-b172e4d888dc8fc00394f444b6462855.png";